/* import __COLOCATED_TEMPLATE__ from './workspace-avatar-modal.hbs'; */
/* RESPONSIBLE TEAM: team-inbox-experience */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import type Admin from 'embercom/models/admin';
// @ts-ignore - DefaultAvatars doesn't have type declarations
import DefaultAvatars from '@intercom/pulse/lib/default-avatars';

interface Args {
  admin: Admin;
  isSaving?: boolean;
  onClose: () => void;
  onUpload: (file: File, useWorkspaceAvatar: boolean) => void;
}

interface Signature {
  Element: HTMLElement;
  Args: Args;
}

export default class WorkspaceAvatarModal extends Component<Signature> {
  @tracked useWorkspaceAvatar = false;
  @tracked selectedFile: File | null = null;
  @tracked previewUrl: string | null = null;

  get adminFirstName(): string {
    return this.args.admin.first_name ?? this.args.admin.name ?? '';
  }

  get adminAvatarUrl(): string {
    return this.args.admin.avatar?.image_urls?.square_128 ?? DefaultAvatars.admins[128];
  }

  get defaultAvatarUrl(): string {
    return DefaultAvatars.admins[128];
  }

  @action
  handleImageError(event: Event): void {
    let img = event.target as HTMLImageElement;
    img.src = this.defaultAvatarUrl;
  }

  get showWorkspaceOnlyOption(): boolean {
    return this.args.admin.hasMoreThanOneApp;
  }

  get isUploadDisabled(): boolean {
    return !this.selectedFile || this.args.isSaving === true;
  }

  @action
  toggleWorkspaceAvatar(): void {
    this.useWorkspaceAvatar = !this.useWorkspaceAvatar;
  }

  @action
  openFilePicker(): void {
    let fileInput = document.querySelector('[data-workspace-avatar-file-input]');
    if (fileInput instanceof HTMLInputElement) {
      fileInput.click();
    }
  }

  @action
  handleFileSelect(event: Event): void {
    let target = event.target as HTMLInputElement;
    let file = target.files?.[0];

    if (file) {
      this.selectedFile = file;

      let reader = new FileReader();
      reader.onload = (e) => {
        this.previewUrl = e.target?.result as string;
      };
      reader.readAsDataURL(file);
    }
  }

  @action
  handleUpload(): void {
    if (this.selectedFile) {
      this.args.onUpload(this.selectedFile, this.useWorkspaceAvatar);
    }
  }

  @action
  handleClose(): void {
    this.useWorkspaceAvatar = false;
    this.selectedFile = null;
    this.previewUrl = null;
    this.args.onClose();
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Account::WorkspaceAvatarModal': typeof WorkspaceAvatarModal;
    'account/workspace-avatar-modal': typeof WorkspaceAvatarModal;
  }
}
